import React from 'react';
import { useStyles } from './style';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Card,
    CardContent,
    Divider,
    FormGroup,
    FormControlLabel,
    Grid,
    Avatar,
    Typography,
    TextField,
    Tooltip,
    TextareaAutosize,
    Table,

    Button,
    Switch,
    IconButton,
    withStyles,

} from '@material-ui/core/';
import Slider from '@material-ui/core/Slider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import PhoneIcon from '@material-ui/icons/Phone';
import { AiOutlineMinus, AiOutlineClose } from 'react-icons/ai'
import { FaUserPlus } from 'react-icons/fa';
import { MdSend, MdScheduleSend, MdOutlineDialpad, MdCall, MdOutlineExpandMore, MdPhonePaused, MdCallEnd, MdOutlineMessage } from 'react-icons/md';
import { BiCheckDouble, BiPlay, BiMessageSquareAdd, BiDialpadAlt, BiChevronDown, BiRectangle } from 'react-icons/bi';
import { RiEditBoxFill, RiUser3Fill, RiPauseCircleFill } from 'react-icons/ri';
import Ellipse from '../../assets/icons/Ellipse.png';
import { AiFillCloseCircle, AiFillStar, AiOutlineEdit, AiOutlinePause } from 'react-icons/ai';
import { GrFormClose } from 'react-icons/gr'
import { InputAdornment } from '@material-ui/core';
import { ImBlocked, ImPhoneHangUp } from 'react-icons/im';
import { IoIosClose, IoMdCall } from 'react-icons/io'
import { BsFillCaretDownFill, BsChatRightText, BsDownload, BsFillMicMuteFill, BsPlusSquareFill, BsWifi, BsFillMicFill, BsFillTelephoneOutboundFill } from 'react-icons/bs';
import { FiSettings } from 'react-icons/fi';
import { CgUserAdd } from 'react-icons/cg';
import CallParkIcon from '../../assets/icons/call-park.png'
import { FcCallTransfer } from 'react-icons/fc';
import { GrAdd } from 'react-icons/gr';
import { VscChromeMaximize } from 'react-icons/vsc'
import Modal from '@material-ui/core/Modal';
// import { CardHeader } from '../Header/CardHeader';
import { ImRedo2 } from 'react-icons/im'
import SaveIcon from '@material-ui/icons/Save';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import { TiArrowForward } from 'react-icons/ti';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import Popup from "reactjs-popup";
import Checkbox from '@material-ui/core/Checkbox';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';
// import { Window, WindowActionsEvent } from "@progress/kendo-react-dialogs";
import './style.css'
import profile from "../../assets/images/avtar.jpg";
import callTransfer from '../../assets/images/callTransfer.jpg'
import axiosInstance from "../../environment/axiosInstance";
import { useHistory } from 'react-router-dom';

export default function IncomingCall(props: any) {
    const history = useHistory();
    const classes = useStyles();
    let start = 0
    let intrvl: any
    const [open, setOpen] = React.useState<boolean>(false);
    const [answered, setAnswered] = React.useState<boolean>(false);
    const [mute, setMute] = React.useState<boolean>(false);
    const [hold, setHold] = React.useState<boolean>(false);
    const [rotation, setRotation] = React.useState(0)
    const [transferOpen, setTransferOpen] = React.useState<boolean>(false);
    const [windowStage, setWindowStage] = React.useState("MAXIMISED");
    const [transferModalStyle] = React.useState(getTransferModalStyle);
    const [timer, setTimer] = React.useState({
        s: "00",
        m: "00",
        h: "00"
    })
    const handleTranferOpen = () => {
        setTransferOpen(true);
    }
    const handleTransferClose = () => {
        setTransferOpen(false);
    }
    const handleOpen = () => {
        setOpen(true);
    }
    const handleMute = () => {
        setMute(!mute)
        if (mute) {
            props.session.unmute()
        } else {
            props.session.mute()
        }
    }
    function setZeros(i: any) {
        if (i < 10) return "0" + i;
        return i;
    }

    //start timer
    const startTimer = () => {
        // if startTimer is already running
        if (start == 1) return;

        start = 1; // set startTimer is running
        let ss = 0,
            mm = 0,
            hh = 0;
        intrvl = setInterval(() => {
            ss++;
            if (ss == 60) {
                ss = 0;
                mm++;
            }
            if (mm == 60) {
                mm = 0;
                hh++;
            }
            setTimer({
                s: setZeros(ss),
                m: setZeros(mm),
                h: setZeros(hh)
            })

        }, 1000);
    }; // start timer ends
    const stopTimer = () => {
        if (start == 0) return;
        start = 0;
        setTimer({
            s: "00",
            m: "00",
            h: "00"
        });
        clearInterval(intrvl);
    }; // stop timer ends
    const handleHold = () => {
        setHold(!hold)
        if (hold) {
            props.session.unhold()
        } else {
            props.session.hold()
        }
    }
    function getTransferModalStyle() {
        const top = 15;
        const left = 30;
        const right = 30;

        return {
            top: `${top}%`,
            left: `${left}%`,
            right: `${right}%`,
            transform: `translate(-${top}%, -${left}%, -${right}%)`,
        };
    }
    const handleAnswerCall = () => {
        if (props.session?._remote_identity?._display_name?.split("#")[0]) {
            axiosInstance
                .get(process.env.REACT_APP_API_URL + "/support/business_owner/call/receive/" + props.session?._remote_identity?._display_name?.split("#")[0])
                .then((response: any) => {
                    if (response.data) {
                        console.log("call answered");
                        props.session.answer(props.options);
                        setAnswered(true)
                        startTimer();
                        history.push("/conversations/" + response.data.Data.customer);

                    }
                });
        }
    }
    const handleEndCall = () => {
        if (props.session?._remote_identity?._display_name?.split("#")[0]) {
            axiosInstance
                .get(process.env.REACT_APP_API_URL + "/support/business_owner/call/decline/" + props.session?._remote_identity?._display_name?.split("#")[0])
                .then(response => {
                    if (response.data) {
                        console.log("call declined");
                        props.session.terminate();
                        props.callModal()
                        props.parentMinimise(false)
                        props.parentEndCall(false)
                        props.end()
                    }
                })
        }
    }
    const handleMinimise = () => {
        props.parentMinimise(false)
    }

    return (
        <Card style={{ background: 'white' }}>
            <div className={classes.smallDiv}>
                <Typography style={{
                    // fontFamily: 'Work Sans', 
                    color: 'green',
                    fontSize: 14
                }}>Incoming...</Typography>
                <div className={classes.divCard}>
                    <Typography>{props.CallRouteFrom}</Typography>
                    <Typography>{props.CallRouteFromPhoneNumber}</Typography>
                </div>
            </div>
            <div className={classes.newJhon}>
                <Typography className={classes.wick}>
                    {
                        props.session?._remote_identity?._display_name?.includes("#") ?
                            props.session?._remote_identity?._display_name?.split("#")[1]
                            :
                            props.session?._remote_identity?._display_name
                    }
                </Typography>
            </div>
            <div className={classes.numberOne}>
                <Typography className={classes.numberTwo}>{props.session?._remote_identity?._uri?._user}</Typography>
            </div>
            {props.callStatus && <div className={classes.timeDivTwo}>
                <Typography className={classes.timeContentTwo} >{props.timer?.m + " : " + props.timer?.s}</Typography>
            </div>
            }

            {!answered ?
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 8, padding: 10 }}>
                        <div style={{}}>
                            <div className={classes.callEnd} onClick={handleEndCall} >
                                <IconButton className={classes.filledIcon}>
                                    <MdCallEnd />
                                </IconButton>
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <div className={classes.callEnd} id="ringing" onClick={handleAnswerCall}>
                                <IconButton className={classes.iconSizeanswer}>
                                    {/* <Icon icon={callEnd16Filled} /> */}
                                    <IoMdCall />
                                </IconButton>
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <div className={classes.callEnd} id="ringing" onClick={handleAnswerCall}>
                                <IconButton className={classes.iconSizeanswerr}>
                                    {/* <Icon icon={callEnd16Filled} /> */}
                                    <MdOutlineMessage />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div>
                    <div style={{}}>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, padding: 10 }}>
                            <div style={{}}>
                                <div className={classes.callEnd} onClick={handleEndCall} >
                                    <IconButton className={classes.filledIcon}>
                                        <MdCallEnd />
                                    </IconButton>
                                </div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                {mute ?
                                    <div onClick={handleMute}>
                                        <IconButton className={classes.filledIcon} style={{ backgroundColor: '#2645AD', color: 'white' }}>
                                            <BsFillMicMuteFill />
                                        </IconButton>
                                    </div> :
                                    <div onClick={handleMute}>
                                        <IconButton className={classes.filledIcon} style={{ backgroundColor: '#2645AD', color: 'white' }}>
                                            <BsFillMicFill />
                                        </IconButton>
                                    </div>
                                }
                                {hold ?
                                    <div onClick={handleHold}>
                                        <IconButton className={classes.filledIcon} style={{ marginLeft: 6 }}>
                                            <BiPlay />
                                        </IconButton>
                                    </div> :
                                    <div onClick={handleHold} style={{ marginLeft: 6 }}>
                                        <IconButton className={classes.filledIcon}>
                                            <AiOutlinePause />
                                        </IconButton>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Card>
    )
}
